/**
 * Names for the CRM orchestrator's slugs, shared by the feeds list and the feed itself.
 *
 * Here rather than in either page because both render the adapter, and a duplicated map is the
 * kind of thing that gets updated in one copy: the day a second adapter lands, one screen would
 * say "Salesforce" and the other "salesforce".
 */

/**
 * How the CRM's own name is spelled.
 *
 * The adapter key is a lowercase slug, and `Asks leadsquared for appointments` reads as a typo
 * in the middle of an English sentence. Unknown adapters fall back to the slug rather than to a
 * guess.
 */
export const ADAPTER_LABEL: Record<string, string> = { leadsquared: "LeadSquared" };

/** What triggered a run, in words. The stored values are terse and two look alike. */
export const POLLER_LABEL: Record<string, string> = {
  intraday: "Scheduled poll",
  reconcile: "Morning catch-up",
  manual: "Run by hand",
  "manual-dry": "Dry run by hand",
  "dry-run": "Dry run (CLI)",
};
